module.exports = __webpack_public_path__ + "static/media/02.12b25c69.png";